var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNecklaceAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 2C2.75 1.58579 2.41421 1.25 2 1.25C1.58579 1.25 1.25 1.58579 1.25 2C1.25 7.93706 6.06294 12.75 12 12.75C17.9371 12.75 22.75 7.93706 22.75 2C22.75 1.58579 22.4142 1.25 22 1.25C21.5858 1.25 21.25 1.58579 21.25 2C21.25 7.10863 17.1086 11.25 12 11.25C6.89137 11.25 2.75 7.10863 2.75 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.617 15.2672L15.7817 16.4949C16.0557 16.7837 16.0737 17.2165 15.8247 17.5248L12.3378 21.8419C12.1675 22.0527 11.8325 22.0527 11.6622 21.8419L8.17532 17.5248C7.92627 17.2165 7.94431 16.7837 8.21825 16.4949L9.38301 15.2672C9.54437 15.0971 9.77432 15 10.0156 15H13.9844C14.2257 15 14.4556 15.0971 14.617 15.2672Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNecklaceAlt);
export default __webpack_public_path__ + "static/media/necklace-alt.bf9c65556e04a8564c95314bc8dee916.svg";
export { ForwardRef as ReactComponent };